import { customElement } from 'lit/decorators.js';
import { PCTeaserCard } from '../pc-teaser-card/pc-teaser-card';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import teaserCardStyles from '../pc-teaser-card/pc-teaser-card.css.lit';
import componentStyles from './pc-promo-card.css.lit';
import { CSSResultArray } from 'lit';
import globalStyles from './pc-promo-card.lightDom.css.lit';

@customElement('pc-promo-card')
export class PCPromoCard extends PCTeaserCard {
  static styles: CSSResultArray = [teaserCardStyles, componentStyles];

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-promo-card': PCPromoCard;
  }
}
